module.exports = __webpack_public_path__ + "static/media/comoLlegar.2034e782.webp";